import {createFileRoute} from '@tanstack/react-router';
import {DepositAccountTransactionsPage} from 'features/deposit/pages/DepositAccountTransactionsPage';

export const Route = createFileRoute(
  '/_protected/home/accounts/deposits/$accountId/transactions',
)({
  component: DepositAccountTransactionsPage,
  staticData: {crumbKey: 'navigation.transactions'},
});
